import { render, staticRenderFns } from "./LanguageFlag.vue?vue&type=template&id=5135da2b&scoped=true&"
import script from "./LanguageFlag.vue?vue&type=script&lang=js&"
export * from "./LanguageFlag.vue?vue&type=script&lang=js&"
import style0 from "./LanguageFlag.vue?vue&type=style&index=0&id=5135da2b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5135da2b",
  null
  
)

export default component.exports